import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WarehouseAdministrativeService {
  private URL = environment.api + "api/warehouseAdministrative";

  constructor(
    private http: HttpClient
  ) { }

  associateWarehouses(warehouseAdminId,warehouseFiscalId) {
    return this.http.post(this.URL + "/relation" + "/" + warehouseAdminId + "/" + warehouseFiscalId,null);
  }

  getAllFiscalWarehouses(companyId) {
    return this.http.get(this.URL + "/allfiscal" + "/" + companyId);
  }

  deleteRelation(adminId: number, fiscalId: number) {
    return this.http.delete(this.URL +`/relation/${adminId}/${fiscalId}`);
  }

}
